<template>
  <b-card class="mt-3">
    <b-row>
      <b-col cols="12" md="8">
        <b-form-group id="input-group-3" label="پیام های آماده:" label-for="input-3">
          <MDDropdown v-bind:group="120" @input="change"></MDDropdown>
        </b-form-group>
        <b-form-file class="d-none" plain ref="attachment" accept="image/jpeg,image/jpg,application/pdf"></b-form-file>
        <b-form-group class="mb-0 mt-4 w-100 border border-2 custom-border rounded">
          <b-input-group>
            <b-form-textarea id="ticket-content" class="form-control-solid py-3 py-lg-4 overflow-hidden resize-none"
              v-model="answer.text" placeholder="پیام خود را وارد کنید." name="content" />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" class="row mt-4 pr-0">
        <b-col cols="5" class="row d-flex justify-content-center pr-7 pl-7 h-170">
          <b-button @click="SendAnswer()" block class="mt-2 mb-2 h-40" variant="warning">ارسال پاسخ</b-button>
          <b-button block :class="'mt-2 mb-2 h-40' +
            (isBusyTechnical ? 'spinner spinner-light spinner-right' : '')
            " variant="primary" @click="AssignToTechnical">ارجاع به فنی</b-button>
          <b-button block class="mt-2 mb-2 h-40" variant="success" @click="CloseTicket">بستن</b-button>
        </b-col>
        <b-col block cols="7" class="mt-2 pr-0 pl-0">
          <b-row>
            <b-col class="col-md-3 mt-3" v-for="(x, index) in answer.files" v-bind:key="x.file_id">
              <b-button class="mr-5" @click="delete_attachment(index)" size="sm">
                <b-icon icon="trash"></b-icon>
              </b-button>
              <a target="_blank" :href="x.fileUrl">پیوست شماره {{ index + 1 }}</a>
            </b-col>
          </b-row>
          <b-form-group id="input-group-4" label-for="input-4">
            <!-- <fileUploader  v-model="ticket.file_id"></fileUploader> -->
            <fileUploader v-model="file" v-bind:fileUploaded="fileUploaded"></fileUploader>
          </b-form-group>
        </b-col>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import MDDropdown from "../../components/MDDropdown";
import fileUploader from "@/components/fileUploader2";
import routesMap from "@/helpers/routesMap";
import httpHelper from "@/helpers/httpHelper";
export default {
  name: "ticketsReply",
  data: function () {
    return {
      file: "",
      files: [],
      routesMap,
      fileUrl: '',
    };
  },
  props: {
    answer: {
      type: Object,
      default: () => { },
    },
    isBusyTechnical: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    MDDropdown,
    fileUploader,
  },
  methods: {
    fileUploaded: async function () {
      const newFile = { file_id: this.file };
      this.files.push(newFile);
      const imageUrl = await httpHelper.getImage(newFile.file_id);
      this.$set(newFile, 'fileUrl', imageUrl.result.url || '');
      this.file = "";
      this.$emit('uploadFile', this.files)
    },
    change(e) {
      this.$emit("change", e);
    },
    SendAnswer() {
      this.$emit("SendAnswer");
    },
    AssignToTechnical() {
      this.$emit("AssignToTechnical");
    },
    CloseTicket() {
      this.$emit("CloseTicket");
    },
    delete_attachment(index) {
      this.$emit("delete_attachment", index);
    },
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.h-40 {
  height: 40px !important;
}

.h-170 {
  height: 170px !important;
}
</style>
